module.exports = __webpack_public_path__ + "static/media/dowjones.7ff535a2.png";